/**
 * SuMappina laktaciju duomenis, kurie JSON objekte yra kaip kitas JSON
 * objektas (pvz. "1", "2", ..., "5+"), o tame objekte yra kiti objektai:
 * "menesis", "pienasDabar", "pienasBuves", "riebBaltDabar", "riebBaltBuves".
 *
 * Funkcija sumappina juos į 4 masyvus: "pienasDabar", "pienasBuves", "riebBaltDabar",
 * "riebBaltBuves", kuriame objektas yra: "menesis", "1 lakt.", "2 lakt.", ..., "5+ lakt.".
 *
 * @param {[]} data pradiniai duomenys.
 * @returns 4 masyvai, dabartiniams ir buvisiems pieno ir riebalų + baltymų kiekkiams pagal
 *          laktacija kas mėnesį.
 */
export function laktacijuProduktyvumoMappinimas(data) {
  // Initialize the arrays to hold transformed data
  const pienasDabarArray = [];
  const riebBaltDabarArray = [];
  const pienasBuvesArray = [];
  const riebBaltBuvesArray = [];

  data.forEach((monthData) => {
    const pienasDabarObj = { Mėnesis: monthData.menesis };
    const riebBaltDabarObj = { Mėnesis: monthData.menesis };
    const pienasBuvesObj = { Mėnesis: monthData.menesis };
    const riebBaltBuvesObj = { Mėnesis: monthData.menesis };

    const lactations = ["1", "2", "3", "4-5", "5+"];

    lactations.forEach((lak) => {
      const lakData = monthData.laktacijos[lak];

      if (lakData) {
        pienasDabarObj[`${lak} lak.`] = lakData.pienasDabar;
        riebBaltDabarObj[`${lak} lak.`] = lakData.riebBaltDabar;
        pienasBuvesObj[`${lak} lak.`] = lakData.pienasBuves;
        riebBaltBuvesObj[`${lak} lak.`] = lakData.riebBaltBuves;
      } else {
        pienasDabarObj[`${lak} lak.`] = null;
        riebBaltDabarObj[`${lak} lak.`] = null;
        pienasBuvesObj[`${lak} lak.`] = null;
        riebBaltBuvesObj[`${lak} lak.`] = null;
      }
    });

    pienasDabarArray.push(pienasDabarObj);
    riebBaltDabarArray.push(riebBaltDabarObj);
    pienasBuvesArray.push(pienasBuvesObj);
    riebBaltBuvesArray.push(riebBaltBuvesObj);
  });

  return {
    pienasDabar: pienasDabarArray,
    riebBaltDabar: riebBaltDabarArray,
    pienasBuves: pienasBuvesArray,
    riebBaltBuves: riebBaltBuvesArray,
  };
}
